import './pbmPromotion.scss';

import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import { useWebContext } from '@/resources/hooks/useWebContext';
import { changeItem } from '@/routes/order';
import { getPbmDiscountCheck } from '@/routes/products';
import { ICartProduct } from '@/store/ducks/order/types';
import { IAlert, IPbmCheckResponse } from '@/store/ducks/products/types';

import Warning from '../../../assets/images/Warning.svg';
import CustomModal from '../../global/CustomModal';
import Load from '../../global/Load';

interface IPbmAlertProps {
  show: boolean;
  onHide: () => void;
  discount: IAlert | null;
  product: ICartProduct | null | undefined;
  orderId: number;
}

export function PbmAlert({ show, onHide, product, orderId }: IPbmAlertProps) {
  const { order } = useWebContext();
  const cartProduct = order?.cart.products.find((item) => item.id === product?.id) || product;
  const [promotions, setPromotions] = useState<IAlert[]>([]);
  const [loading, setLoading] = useState(false);

  const handleDecreaseQuantity = async () => {
    if (!cartProduct) return;
    try {
      await changeItem(
        orderId,
        {
          ean: cartProduct?.ean,
          quantity: cartProduct.quantity - 1,
          product_id: cartProduct?.product_id,
          options: [],
          uid: cartProduct?.uid,
        },
        true,
      );
      onHide();
    } catch (error) {
      console.error('Erro ao alterar quantidade:', error);
    }
  };

  const getDiscounts = async () => {
    const response: IPbmCheckResponse | any = await getPbmDiscountCheck({
      order_id: order?.id as number,
      full_product_id: product?.id as number,
      ean: product?.ean as string,
      quantity: 1,
    });

    if (response?.prices) {
      setPromotions(response.prices);
    }
    return [];
  };

  useEffect(() => {
    setLoading(true);
    if (product?.id) {
      getDiscounts().finally(() => setLoading(false));
    }
  }, [product]);

  return (
    <CustomModal show={show} onHide={onHide} centered>
      <Modal.Body
        className="d-flex justify-content-center align-items-center flex-column p-3"
        style={{ userSelect: 'none' }}
      >
        <div className="d-flex justify-content-center mb-3">
          <img src={Warning} alt="Warning icon" />
        </div>
        <h5 className="text-center" style={{ fontWeight: '700', fontSize: '1.5rem' }}>
          Você perderá o desconto de
          <br />
          laboratório ao alterar a quantidade!
        </h5>
        <p className="text-center" style={{ fontSize: '0.875rem' }}>
          O desconto deste produto é válido apenas em{' '}
          {loading ? (
            <Load color={'primary'} />
          ) : (
            `${promotions.map((p) => p.quantity).join(', ')} un.`
          )}
        </p>
      </Modal.Body>
      {loading ? null : (
        <Modal.Footer
          className={`d-flex justify-content-${loading ? 'center' : 'between'} align-items-center`}
        >
          <button
            className="btn btn-outline-primary pbm-alert-button"
            onClick={handleDecreaseQuantity}
            disabled={!product}
          >
            Diminuir quantidade
          </button>
          <button className="btn btn-primary pbm-alert-button" onClick={onHide}>
            Manter desconto
          </button>
        </Modal.Footer>
      )}
    </CustomModal>
  );
}
